export function getImgUrl(pic: string): string {
  return require("@/assets/" + pic);
}
